
// src/actions/kpi-chart.js

import api from './gamba-api'
import { emitAlertMessage, clearAlertMessage } from './alert-message'

export const FETCH_KPI_CHART = "FETCH_KPI_CHART"
export const FETCH_KPI_CHART_REQUESTED = "FETCH_KPI_CHART_REQUESTED"
export const FETCH_KPI_CHART_COMPLETED = "FETCH_KPI_CHART_COMPLETED"
export const FETCH_KPI_CHART_FAILED = "FETCH_KPI_CHART_FAILED"
export const CLEAR_KPI_CHART = "CLEAR_KPI_CHART"

export function clearKpiChart() {
  return {
    type: CLEAR_KPI_CHART
  }
}

export function fetchKpiChartRequested() {
  return {
    type: FETCH_KPI_CHART_REQUESTED
  }
}

export function fetchKpiChart(kpi_id, group_id) {
  return function(dispatch) {
    dispatch(fetchKpiChartRequested())
    return api.get(`/kpi_status/${kpi_id}`, { group_id })
        .then((results)=> {
          dispatch(fetchKpiChartCompleted(results))
        })
        .catch((error)=> {
          Promise.all([
            dispatch(fetchKpiChartFailed(error)),
            dispatch(emitAlertMessage(error, 'error'))
          ])
        })
  }
}

export function fetchKpiChartCompleted(results) {
  return {
    type: FETCH_KPI_CHART_COMPLETED,
    results,
  }
}

export function fetchKpiChartFailed(error) {
  return {
    type: FETCH_KPI_CHART_FAILED,
    error,
  }
}

export const UPDATE_KPI_ACTUAL_RECORD = "UPDATE_KPI_ACTUAL_RECORD"
export const UPDATE_KPI_ACTUAL_RECORD_REQUESTED = "UPDATE_KPI_ACTUAL_RECORD_REQUESTED"
export const UPDATE_KPI_ACTUAL_RECORD_COMPLETED = "UPDATE_KPI_ACTUAL_RECORD_COMPLETED"
export const UPDATE_KPI_ACTUAL_RECORD_FAILED = "UPDATE_KPI_ACTUAL_RECORD_FAILED"

export function updateKpiActualRecordRequested() {
  return {
    type: UPDATE_KPI_ACTUAL_RECORD_REQUESTED
  }
}

export function updateKpiActualRecord(kpi_id, reported_at, actual, group_id, user_id) {
  return function(dispatch) {
    dispatch(updateKpiActualRecordRequested())
    return api.put(`/kpi_status/${kpi_id}`, { reported_at, actual, group_id, user_id })
        .then((results)=> {
          dispatch(updateKpiActualRecordCompleted(results))
        })
        .catch((error)=> {
          Promise.all([
            dispatch(updateKpiActualRecordFailed(error)),
            dispatch(emitAlertMessage(error, 'error'))
          ])
        })
  }
}

export function updateKpiActualRecordCompleted(results) {
  return {
    type: UPDATE_KPI_ACTUAL_RECORD_COMPLETED,
    results,
  }
}

export function updateKpiActualRecordFailed(error) {
  return {
    type: UPDATE_KPI_ACTUAL_RECORD_FAILED,
    error,
  }
}

export const FETCH_KPI_LIST = "FETCH_KPI_LIST"
export const FETCH_KPI_LIST_REQUESTED = "FETCH_KPI_LIST_REQUESTED"
export const FETCH_KPI_LIST_COMPLETED = "FETCH_KPI_LIST_COMPLETED"
export const FETCH_KPI_LIST_FAILED = "FETCH_KPI_LIST_FAILED"

export function fetchKpiListRequested() {
  return {
    type: FETCH_KPI_LIST_REQUESTED
  }
}

export function fetchKpiList(group_id, reported_at = undefined) {
  return function(dispatch) {
    dispatch(fetchKpiListRequested())
    return api.get(`/kpi_status`, { group_id, reported_at })
        .then((results)=> {
          dispatch(fetchKpiListCompleted(results))
        })
        .catch((error)=> {
          Promise.all([
            dispatch(fetchKpiListFailed(error)),
            dispatch(emitAlertMessage(error, 'error'))
          ])
        })
  }
}

export function fetchKpiListCompleted(results) {
  return {
    type: FETCH_KPI_LIST_COMPLETED,
    results,
  }
}

export function fetchKpiListFailed(error) {
  return {
    type: FETCH_KPI_LIST_FAILED,
    error,
  }
}




// WEBPACK FOOTER //
// ./src/actions/kpi-chart.js